export var FeatureFlags;
(function (FeatureFlags) {
    FeatureFlags["QBO"] = "qbo";
    FeatureFlags["Workflows"] = "workflows";
    FeatureFlags["Quotes"] = "quotes";
    FeatureFlags["MonthlyLateFees"] = "monthlyLateFees";
    FeatureFlags["Escalations"] = "escalations";
    FeatureFlags["AI"] = "ai";
})(FeatureFlags || (FeatureFlags = {}));
export var UserTypes;
(function (UserTypes) {
    /** Gained access via external permissions */
    UserTypes["Inherit"] = "inherit";
    /** @todo Invited within Paidnice */
    UserTypes["Invited"] = "invited";
    /** Paidnice Support */
    UserTypes["Support"] = "support";
    /** Synthetic AI agent user */
    UserTypes["AiAgent"] = "ai_agent";
})(UserTypes || (UserTypes = {}));
//# sourceMappingURL=user.js.map